module.exports = __webpack_public_path__ + "img/video1-poster-pc.8c0490cb.png";